module.exports = __webpack_public_path__ + "img/Barbados.4bbb9156.gif";